const PRIMARY_DARK = "#282828";
const DARK = "#212529";

const WHITE = "#FFFFFF";

const GREEN = "#ABC44E";
const GREEN_HOVER = "#778935";

const GRAY = "#F7F7F7";
const GRAY_TWO = "#BFBFBF";
const GRAY_THREE = "#DEE2E6";

const PRIMARY_YELLOW = "#FEBF00";
const YELLOW = "#FDCA31";
const BLUE = "#0a58ca";

export {
  PRIMARY_DARK,
  DARK,
  WHITE,
  GREEN,
  GREEN_HOVER,
  GRAY,
  GRAY_TWO,
  GRAY_THREE,
  PRIMARY_YELLOW,
  YELLOW,
  BLUE,
};
